import type { WorkspaceSnapshot } from './workspaceStorage'

export interface RemoteWorkspace {
  version: number
  snapshot: WorkspaceSnapshot
}

export class WorkspaceApiError extends Error {
  constructor(readonly status: number, readonly code: string, message: string) {
    super(message)
  }
}

async function responseJson(response: Response) {
  return response.json().catch(() => ({})) as Promise<Record<string, unknown>>
}

export async function loadRemoteWorkspace(): Promise<RemoteWorkspace> {
  const response = await fetch('/api/workspace', { credentials: 'include', cache: 'no-store' })
  const result = await responseJson(response)
  if (!response.ok) throw new WorkspaceApiError(response.status, String(result.code ?? 'WORKSPACE_LOAD_FAILED'), String(result.message ?? 'Não foi possível carregar os dados do StarTracker.'))
  return result as unknown as RemoteWorkspace
}

export async function saveRemoteWorkspace(version: number, snapshot: WorkspaceSnapshot): Promise<RemoteWorkspace> {
  const response = await fetch('/api/workspace', {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': crypto.randomUUID() },
    body: JSON.stringify({ version, snapshot }),
  })
  const result = await responseJson(response)
  if (!response.ok) throw new WorkspaceApiError(response.status, String(result.code ?? 'WORKSPACE_SAVE_FAILED'), String(result.message ?? 'Não foi possível salvar os dados do StarTracker.'))
  return result as unknown as RemoteWorkspace
}

export async function mutateRemoteWorkspace(base: RemoteWorkspace, snapshot: WorkspaceSnapshot): Promise<RemoteWorkspace> {
  const response = await fetch('/api/workspace/mutations', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Idempotency-Key': crypto.randomUUID() },
    body: JSON.stringify({ base, snapshot }),
  })
  const result = await responseJson(response)
  if (!response.ok) throw new WorkspaceApiError(response.status, String(result.code ?? 'WORKSPACE_SAVE_FAILED'), String(result.message ?? 'Não foi possível salvar os dados do StarTracker.'))
  return result as unknown as RemoteWorkspace
}
